import { StoreService } from './../store.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ROUTES } from './menu-items';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../core/service/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MyprofileService, } from '../../core/service/myprofile.service'
declare var $: any;

@Component({
  selector: 'app-sidebar',
  styleUrls: ['./sidebar.component.css'],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  constructor(private modalService: NgbModal,
    private router: Router,
    private auth: AuthenticationService,
    private route: ActivatedRoute, private storeService: StoreService, private sanitizer: DomSanitizer, private myprofileService: MyprofileService) { }

  public username
  imagepreview: any = "assets/images/big/icon-user-default.png"
  isloading
  showMenu = '';
  showMenu1 = '';
  showSubMenu = '';
  public sidebarnavItems: any[];
  // this is for the open close
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addExpandClass1(element: any) {
    if (element === this.showMenu1) {
      this.showMenu1 = '0';
    } else {
      this.showMenu1 = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }
  Logout() {
    this.auth.logout();
  }
  myprofile() {
    this.router.navigate(["./webapps/user-profile/my-profile"]);
  }
  changePassword() {
    this.router.navigate(["./webapps/updatePassword"]);
  }

  getuserName() {                                 //user name implemented by Gaurav
    this.auth.getusername();
    this.auth.getUsernameListner()
      .subscribe((data: { Name: string; SigningWay: string, Picture: string }) => {
        this.username = data.Name;
        // if (data.SigningWay == "google") {
        //   this.imagepreview = data.Picture;
        //   if (data.Picture == undefined || data.Picture == null) {
        //     this.imagepreview = "assets/images/big/icon-user-default.png"
        //   }
        // }
      });
  }

  getuserimage() {
    this.myprofileService.getmyProfileData().subscribe(profile => {
      if (profile.Ref_FileId != null) {
        this.myprofileService.getmyProfileImageData(profile.Ref_FileId)
          .subscribe(Response => {
            // console.log(Response)
            var ImageData = Response.Response["ImageData"];
            // console.log("File Id is: - " + ImageData);
            this.imagepreview = this.sanitizer.bypassSecurityTrustUrl(ImageData);
            this.isloading = true;
          });
      }
      
      else {
        this.imagepreview = "assets/images/big/icon-user-default.png"
        if (profile.myProfileView[0].SigningWay == "google") {
          this.imagepreview = profile.myProfileView[0].Picture;
          if (profile.myProfileView[0].Picture == undefined || profile.myProfileView[0].Picture == null) {
            this.imagepreview = "assets/images/big/icon-user-default.png";
          }
        }
        this.isloading = true;
      }
    });

  }

  // End open close
  ngOnInit() {
    this.getuserName();
    this.getuserimage();
    this.storeService.isProfileUpdated()
      .subscribe(response => {
        if (response) {
          this.getuserimage();
        }
      })

    this.sidebarnavItems = ROUTES.filter(sidebarnavItem => sidebarnavItem);
  }
}
